// ============================================================
// 🔒 MÍDIAS COM PROPÓSITO — LOCKED 2026-05-02
// DO NOT MODIFY WITHOUT EXPLICIT AUTHORIZATION FROM GIOVANNI
// Default skin: s1 (White + Purple) — FINAL
// ============================================================
import React, { createContext, useContext, useState, useEffect } from 'react';
import { SKIN_CONFIGS, SKIN_CONFIG_MAP, type SkinConfig } from '@/lib/index';

interface SkinContextType {
  activeSkin: SkinConfig;
  setSkin: (id: string) => void;
}

const SkinContext = createContext<SkinContextType>({
  activeSkin: SKIN_CONFIGS[0], // 🔒 default = s1 (White + Purple)
  setSkin: () => {},
});

export function SkinProvider({ children }: { children: React.ReactNode }) {
  const [skinId, setSkinId] = useState<string>(() => {
    return localStorage.getItem('mcp-skin') || 's1'; // 🔒 default = s1
  });

  const activeSkin = SKIN_CONFIG_MAP[skinId] ?? SKIN_CONFIGS[0];

  useEffect(() => {
    localStorage.setItem('mcp-skin', skinId);
    document.documentElement.setAttribute('data-skin', skinId);
    document.body.className = `skin-${skinId.replace('s', '')}`;
  }, [skinId]);

  return (
    <SkinContext.Provider value={{ activeSkin, setSkin: setSkinId }}>
      {children}
    </SkinContext.Provider>
  );
}

export function useSkin() {
  return useContext(SkinContext);
}
